module.exports = __webpack_public_path__ + "img/proxy-datacenters.1ae61348.svg";